export default __webpack_public_path__ + "static/logo-699a76b3ce8eb18575e34f404a104217.svg";